 import { createSlice } from "@reduxjs/toolkit";
// // Read persisted state from localStorage (if available)
// const persistedState = JSON.parse(localStorage.getItem("authState")) || null;

// const initialState = persistedState || {
//   isLoggedIn: false,
//   user: null,
//   accessToken: null,
//   googleToken: null,
//   tokenExpiryTime: null,
// };

// const authSlice = createSlice({
//   name: "auth",
//   initialState,
//   reducers: {
// loginSuccess: (state, action) => {
//   const { user, accessToken, googleToken, tokenExpiryTime } = action.payload;
//   state.isLoggedIn = true;
//   state.user = user;
//   state.accessToken = accessToken;
//   state.googleToken = googleToken || null;
//   state.tokenExpiryTime = tokenExpiryTime || null;

//   // Safely store a clone, not the immer draft
//   localStorage.setItem("authState", JSON.stringify({
//     isLoggedIn: state.isLoggedIn,
//     user: state.user,
//     accessToken: state.accessToken,
//     googleToken: state.googleToken,
//     tokenExpiryTime: state.tokenExpiryTime
//   }));
// },

//     logout: (state) => {
//       state.isLoggedIn = false;
//       state.user = null;
//       state.accessToken = null;
//       state.googleToken = null;
//       state.tokenExpiryTime = null;

//       localStorage.removeItem("authState");
//     },
//   },
// });

// export const { loginSuccess, logout } = authSlice.actions;
// export default authSlice.reducer;
// import { createSlice } from "@reduxjs/toolkit";

const persistedState = JSON.parse(localStorage.getItem("authState"));

const initialState = persistedState || {
  isLoggedIn: false,
  user: null,
  accessToken: null,
  tokenExpiryTime: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {

    loginSuccess: (state, action) => {

      const { user, accessToken, tokenExpiryTime } = action.payload;

      state.isLoggedIn = true;
      state.user = user;
      state.accessToken = accessToken;
      state.tokenExpiryTime = tokenExpiryTime;

      const persistData = {
        isLoggedIn: true,
        user,
        accessToken,
        tokenExpiryTime
      };

      localStorage.setItem("authState", JSON.stringify(persistData));
    },

    logout: (state) => {

      state.isLoggedIn = false;
      state.user = null;
      state.accessToken = null;
      state.tokenExpiryTime = null;

      localStorage.removeItem("authState");
    },

  },
});

export const { loginSuccess, logout } = authSlice.actions;

export default authSlice.reducer;